import React, { useState } from "react";
import { AdvancingTemplateState } from "./model";
import { EditSectionTemplate } from "components/MainSectionTemplate/EditSectionTemplate";
import { routes } from "utilities/routing/generatedRoutes";
import RequiredTextInput from "components/ValidatedFields/RequiredTextInput";
import { TemplateEditForm } from "./components/TemplateEditForm";

interface AdvancingTemplateDetailSectionProps {
  advancingTemplate: server.dto.AdvancingTemplate
  allFormSections: server.dto.AdvancingFormSection[]
}

export const AdvancingTemplateDetailSection = (props: AdvancingTemplateDetailSectionProps) => {
  const [advancingTemplate, setAdvancingTemplate] = useState<AdvancingTemplateState>({
    name: props.advancingTemplate.name,
    templateItems: props.advancingTemplate.formItems
  });

  const submit = () => {
    return window.CoreApi.AdvancingTemplate.UpdateTemplate({
      advancingTemplateId: props.advancingTemplate.advancingTemplateId,
      name: advancingTemplate.name,
      formItems: advancingTemplate.templateItems
    })
  }

  // TODO: Here we are using the EditTemplate as well. We should refactor this
  //  to use the detail template sometime in the future.
  return <EditSectionTemplate
    submit={submit}
    redirectUrl={() => routes.advancingTemplate_List().absolute}
    sections={[{
      key: "advancingTemplate",
      type: "regular",
      title: RESX.Advancing.AdvancingTemplate,
      fields: [{
        key: "name",
        hideLabel: true,
        label: RESX.GeneralLabels.Name,
        renderEditNew: () => <div style={{
          paddingLeft: 8,
        }}><RequiredTextInput
            validatorKey="title"
            focusOnMount
            maxLength={serverReference.constants.advancingTemplate.maxNameLength}
            value={advancingTemplate.name}
            onChange={(name) => { setAdvancingTemplate({ ...advancingTemplate, name }); }}
          />
        </div>
      }, {
        key: "formSections",
        hideLabel: true,
        label: "",
        renderEditNew: () => <div style={{
          paddingLeft: 8,
        }}>
          <TemplateEditForm
            allFormSections={props.allFormSections}
            templateItems={advancingTemplate.templateItems}
            onChange={templateItems => setAdvancingTemplate({ ...advancingTemplate, templateItems })}
          />
        </div>
      }]
    }]}
  />
}